mutation RemoveChatLine($input: StreamToolsRemoveChatLineInput!) {
  StreamToolsRemoveChatLine(input: $input) {
    removed
  }
}
